module.exports = __webpack_public_path__ + "img/male_7.dd866c46.png";